import { render, staticRenderFns } from "./ManutencaoAgenda.vue?vue&type=template&id=4bfd4001"
import script from "./ManutencaoAgenda.vue?vue&type=script&lang=js"
export * from "./ManutencaoAgenda.vue?vue&type=script&lang=js"
import style0 from "./ManutencaoAgenda.vue?vue&type=style&index=0&id=4bfd4001&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports